import { createAction } from "@reduxjs/toolkit";
import * as types from "../types/actions";

export const checkinAuth = createAction(types.CHECKINAUTH);
export const checkinGeneric = createAction(types.CHECKIN_GENERIC);
export const setIsGenericCheckin = createAction(types.SET_IS_GENERIC_CHECKIN);
export const additionalDriverAuth = createAction(types.ADDITIONAL_DRIVER_AUTH);
export const checkin = createAction(types.CHECKIN);
export const checkout = createAction(types.CHECKOUT);

export const getBrandLocations = createAction(types.GET_BRAND_LOCATIONS);
export const saveReservationOptions = createAction(types.SAVERESERVATIONOPTIONS);
export const retrieveCustomer = createAction(types.RETRIEVECUSTOMER);
export const retrieveReservation = createAction(types.RETRIEVERESERVATION);
export const resEstimate = createAction(types.RESESTIMATE);
export const resOptions = createAction(types.RESOPTIONS);
export const getDetails = createAction(types.GETDETAILS);
export const updateReservation = createAction(types.UPDATERESERVATION);
export const searchCustomer = createAction(types.SEARCHCUSTOMER);
export const updateReservationAndCustomer = createAction(types.UPDATERESERVATIONANDCUSTOMER);
export const manualUpdateReservationAndCustomerFromIdvResult = createAction(types.MANUAL_UPDATERESERVATIONANDCUSTOMER);
export const manualCreateNewCustomer = createAction(types.MANUAL_CREATE_CUSTOMER);
export const manualUpdateCustomer = createAction(types.MANUAL_UPDATE_CUSTOMER);
export const updateReservationAndCustomerCIF = createAction(types.UPDATERESERVATIONANDCUSTOMER_CIF);
export const frontdeskGetEstimate = createAction(types.FRONTDESKRESESTIMATE);
export const sendEmailNotification = createAction(types.SENDNOTIFICATION);
export const searchAddress = createAction(types.SEARCHADDRESS);
export const retrieveAddress = createAction(types.RETRIEVEADDRESS);
export const verifyEmail = createAction(types.VERIFYEMAIL);
export const verifyPhone = createAction(types.VERIFYPHONE);
export const repairAddress = createAction(types.REPAIRADDRESS);
export const updateCustomerContact = createAction(types.UPDATECUSTOMERCONTACT);
export const createNewCustomer = createAction(types.CREATE_CUSTOMER);
export const updateCustomer = createAction(types.UPDATE_CUSTOMER);
export const resetVerifyStatus = createAction(types.RESETVERIFYSTATUS);
export const resetIDVerifyStatus = createAction(types.RESET_ID_VERIFY_STATUS);
export const setCheckinDemo = createAction(types.SET_CHECKIN_DEMO);
export const setRequireReVerifyCC = createAction(types.SET_REQUIRE_REVERIFY_CC);
export const setRequireReVerifyID = createAction(types.SET_REQUIRE_REVERIFY_ID);
export const getOcrLabsOutage = createAction(types.GET_UPCOMING_OCRLABS_OUTAGE);
export const idVerificationSkipped = createAction(types.ID_VERIFICATION_SKIPPED);
export const idVerificationRequired = createAction(types.ID_VERIFICATION_REQUIRED);

export const extendSession = createAction(types.EXTEND_SESSION);

export const createToast = createAction(types.CREATE_TOAST);

export const requestWindcaveHpp = createAction(types.REQUEST_WINDCAVEHPP);
export const requestWindcaveStatus = createAction(types.WINDCAVE_STATUS);
export const windcaveUpdate = createAction(types.WINDCAVE_UPDATE);
export const windcaveSkip = createAction(types.WINDCAVE_SKIP);

export const requestIdVerificationTransaction = createAction(types.REQUEST_IDVERIFICATION_TRANSACTION);
export const requestIdVerificationStatus = createAction(types.REQUEST_IDVERIFICATION_STATUS);
export const idvSkip = createAction(types.IDV_SKIP); // doesnt use
export const sendSMSInvite = createAction(types.SEND_SMS_INVITE);

export const logout = createAction(types.LOGOUT);
